import React, { useRef } from 'react';
import styles from '../styles/branchpage.module.scss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import FeaturedBlogs from './FeaturedBlogs';
import WebinarEvents from './WebinarEvents';
import SeveneasySteps from './SeveneasySteps';
import Testimonial from './Testimonial';
import KcNewLatestUpdates from './kcNewlatestupdates';
import { useRouter } from 'next/router';
import CustomLink from './CustomLink';
import CustomImage from './CustomImage';
import Ratio from 'react-bootstrap/Ratio';
import { isFrappeOrJotFormClass } from '../utils/helpers';
import LazyMedia from './LazyMedia';

const Branchpage: React.FC = (props: any) => {
  const router = useRouter();
  const branchDetails = props.branchData[0];
  const scrollRef = useRef<HTMLDivElement>(null);
  const getBranchName = (branchName: string) => {
    if (branchName.includes('(')) {
      const regExp = /\(([^)]+)\)/;
      const matches = regExp.exec(branchName);
      const cityName = branchName.split('(')[0];
      return matches && matches?.length > 0 ? matches[1] + ' ' + cityName : '';
    } else return branchName;
  };
  return (
    <>
      <div id='branchheading' className={styles.edtech}>
        <Container>
          <div className={styles.breadcrum}>
            <Row className='text-center'>
              <Col lg={10} md={12} sm={12} xs={12} className={styles.centered}>
                <Breadcrumb>
                  <Breadcrumb.Item style={{ opacity: 0.5 }} href='/'>
                    Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item href=''>
                    {branchDetails?.city} Branch
                  </Breadcrumb.Item>
                </Breadcrumb>
                <div className={styles.abttopContent}>
                  <div className={styles.abttopContentdesk}>
                    <h1>KC Overseas Education {branchDetails?.city} <br /> {branchDetails?.area && branchDetails.area} </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Row>
            <Col sm={12} xs={12} md={12}>
              <div className={styles.centerContent}>
                <p>
                  We value your career aspirations, which is why we map your
                  preferences with the best that our global universities have to
                  offer. Thousands of our students are pursuing their programs
                  and aspirations in eminent universities globally and we
                  welcome you to pursue yours!
                </p>
                <div>
                  For more information connect with the leading study abroad
                  consultant in {getBranchName(branchDetails?.city)} .
                </div>
                <div className={styles.btcontainer}>
                  <Row>
                    <Col sm={12} xs={12} md={6}>
                      <div>
                          {branchDetails?.meta?.jotforms[0]?.jotformid ? (
                            <Button
                              variant='primary'
                              size='lg'
                              className={`${isFrappeOrJotFormClass(branchDetails?.meta?.jotforms[0]?.jotformid)} ${styles.btInquiry}`}
                            >
                              Enquire Now
                            </Button>
                          ) : (
                            <Button
                              variant='primary'
                              size='lg'
                              className={`${isFrappeOrJotFormClass(process.env.NEXT_PUBLIC_COMMON_FRAPPE_FORM)} ${styles.btInquiry}`}
                            >
                              Enquire Now
                            </Button>
                          )}
                        </div>
                    </Col>
                    <Col sm={12} xs={12} md={6}>
                      <div
                        className={styles.btBranchaddress}
                        onClick={() => scrollRef?.current?.scrollIntoView()}
                      >
                        <CustomImage
                          src='/new-images/bt-branch-address.svg'
                          alt='Bt_BranchAddress'
                          width={48}
                          height={48}
                        />
                        Branch Address
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    
      <div id='popular-universities' className={styles.popularUniversities}>
        <Container>
          <h2>Services we provide</h2>
          <Row>
            <Col xs={12} lg={6}>
              <ul>
                <li>
                  <CustomImage
                    src='/new-images/test-icon.svg'
                    alt='testIcon'
                    width={24}
                    height={30}
                  />
                  Test Preparation & Coaching
                </li>
                <li>
                  <CustomImage
                    src='/new-images/app-icon.svg'
                    alt='appIcon'
                    width={30}
                    height={30}
                  />
                  Application Assistance
                </li>
                <li>
                  <CustomImage
                    src='/new-images/edu-icon.svg'
                    alt='eduIcon.svg'
                    width={30}
                    height={30}
                  />
                  Education Loan & Fee Payments
                </li>
                <li>
                  <CustomImage
                    src='/new-images/stud-icon.svg'
                    alt='studIcon.svg'
                    width={30}
                    height={30}
                  />
                  Student Visa Assistance
                </li>
                <li>
                  <CustomImage
                    src='/new-images/travel.svg'
                    alt='preDepIcon.svg'
                    width={30}
                    height={30}
                  />
                  Travel Assistance
                </li>
              </ul>
            </Col>
            <Col xs={12} lg={6}>
              <ul>
                <li>
                  <CustomImage
                    src='/new-images/course-icon-a.svg'
                    alt='courseIcon.svg'
                    width={25}
                    height={30}
                  />
                  Course, Country & University Selection
                </li>
                
                <li>
                  <CustomImage
                    src='/new-images/schol-icon.svg'
                    alt='scholIcon.svg'
                    width={30}
                    height={30}
                  />
                  Scholarship Assistance
                </li>
                <li>
                  <CustomImage
                    src='/new-images/accommodation.svg'
                    alt='insuIcon.svg'
                    width={30}
                    height={30}
                  />
                  Accommodation Assistance
                </li>

                <li>
                  <CustomImage
                    src='/new-images/insu-icon.svg'
                    alt='insuIcon.svg'
                    width={30}
                    height={30}
                  />
                  Insurance, Forex & Remittance Assistance
                </li>
                
                <li>
                  <CustomImage
                    src='/new-images/pre-dep-icon.svg'
                    alt='preDepIcon.svg'
                    width={30}
                    height={30}
                  />
                  Pre-Departure Orientation
                </li>
               
              </ul>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row className='text-center'>
            <Col>
               <div>
                    {branchDetails?.meta?.jotforms[0]?.jotformid ? (
                      <Button
                        variant='primary'
                        size='lg'
                        className={`${isFrappeOrJotFormClass(branchDetails?.meta?.jotforms[0]?.jotformid)} ${styles.btInquiry}`}
                      >
                        Enquire Now
                      </Button>
                    ) : (
                      <Button
                        variant='primary'
                        size='lg'
                        className={`${isFrappeOrJotFormClass(process.env.NEXT_PUBLIC_COMMON_FRAPPE_FORM)} ${styles.btInquiry}`}
                      >
                        Enquire Now
                      </Button>
                    )}
                  </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div id='studycntbranch' className={styles.studyContent}>
        <Container>
          <Row>
            <Col xs={12} lg={6}>
              <CustomImage
                src='/realize.svg'
                alt='realize.svg'
                width={490}
                height={440}
              />
            </Col>
            <Col xs={12} lg={6} className={styles.contentAlign}>
              <div className={styles.offers}>
                <h3>Realize your global ambitions with us</h3>
                <p>
                  With a keen ear for your choices and preferences, our
                  counselling experience is so seamless that you will land in
                  your dream university even before you do!
                </p>
                <ul>
                  <li>Virtual & In Person Coaching and Counselling</li>
                  <li>
                    Comprehensive Assistance for Applications, Admissions &
                    Visas
                  </li>
                  <li>High Value Scholarships and Study Loans</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {branchDetails?.testimonial &&     
        <div id='videobranch' style={{ backgroundColor:`${branchDetails.testimonial?.sectionBgColor}`}}>
        <Container className={styles.videobranch}>
            <Row>
              <Col xs={12} lg={12} className="text-center"> 
               <h2 className='mb-5'>{branchDetails.testimonial?.title}</h2>
              </Col>
              </Row>
              <Row>
              <Col xs={12} lg={12} className="text-center position-relative mb-5"> 
              <div className={styles.videoBase}  
              style={{ backgroundColor:`${branchDetails.testimonial?.videoBgColor}`}}
              ></div>
              <div className={styles.videoPlaceholder}>
                    <Ratio aspectRatio='16x9'>
                      <LazyMedia tag='embed' type='image/svg+xml' src={branchDetails.testimonial?.videoLink} />
                    </Ratio>
               </div>
              </Col>
              </Row>
         </Container>
        </div>
      }   
      
      <div id='uni-tieup' className={styles.uniTieUp}>
        <Container>
          <Col xs={12} lg={12} className='text-center'>
            <div className={styles.uniDiv}>
              <h2>Take your first step with KC</h2>
            </div>
          </Col>
          <Row>
            <Col xs={12} lg={6}>
              <div className={styles.uniDiv}>
                <h3>Test Preparation</h3>
                {(router.asPath.includes(
                  'contact-us/study-abroad-consultants-in-raipur'
                ) && (
                    <p>
                      Welcome to KC Academy’s IELTS Coaching in Raipur! We provide
                      highly motivated and skilled tutors, who have over two
                      decades of expertise of driving thousands of ambitious test
                      seekers like you to excellence. Our students routinely
                      achieve top test scores, thanks to the exceptional tutoring
                      by our passionate and accomplished faculties and our test
                      prep methodologies that are highly effective, yet are easy,
                      interactive & fun. Get the score you are aiming for SAT,
                      ACT, GRE, GMAT, TOEFL, PTE, and IELTS classes. Enrol with us
                      for test preparation coaching in Raipur.
                    </p>
                  )) || (
                    <p>
                      Reach your highest potential test score effortlessly with
                      the exceptional tutoring of our passionate and accomplished
                      tutors and our highly effective and engaging test prep
                      methodologies.
                    </p>
                  )}
              </div>
              <div className={styles.offers}>
                <h4>Offerings</h4>
                <ul>
                  <li>Access top quality test-prep material</li>
                  <li>Interactive online audio/video content</li>
                  <li>Small class sizes – personalized attention</li>
                  <li>Rich database of practice questions</li>
                  <li>Mock tests simulating real test environment</li>
                </ul>
              </div>
                {branchDetails?.meta?.jotforms[0]?.jotformid ? (
                  <button
                    className={`${isFrappeOrJotFormClass(branchDetails?.meta?.jotforms[0]?.jotformid)} ${styles.btInquiryNobg}`}
                  >
                    Enquire Now
                  </button>
                ) : (
                  <button
                    className={`${isFrappeOrJotFormClass(process.env.NEXT_PUBLIC_COMMON_FRAPPE_FORM)} ${styles.btInquiryNobg}`}
                  >
                    Enquire Now
                  </button>
                )}
                      
            </Col>
            <Col xs={12} lg={6}>
              <div className={styles.firstStep}>
                <Row className='text-center'>
                  <Col
                    xl={6}
                    md={6}
                    xs={6}
                    className={`${styles.cols} ${styles.borderl0}`}
                  >
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/ieltslogo.svg'
                        alt='ieltslogo.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>
                  <Col xl={6} md={6} xs={6} className={styles.cols}>
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/etstofel.svg'
                        alt='etstofel.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>
                  <Col
                    xl={6}
                    md={6}
                    xs={6}
                    className={`${styles.cols} ${styles.borderl0}`}
                  >
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/pearson.svg'
                        alt='pearson.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>
                  <Col xl={6} md={6} xs={6} className={styles.cols}>
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/act.svg'
                        alt='act.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>
                  <Col
                    xl={6}
                    md={6}
                    xs={6}
                    className={`${styles.cols} ${styles.borderl0}`}
                  >
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/new-images/gmat-icon.svg'
                        alt='gMat.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>
                  <Col xl={6} md={6} xs={6} className={`${styles.cols} `}>
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/new-images/ets-gre.svg'
                        alt='/new-images/ets-gre.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>

                  <Col
                    xl={12}
                    md={12}
                    xs={12}
                    className={`${styles.cols} ${styles.border0} ${styles.borderl0}`}
                  >
                    <div className={styles.unidiv}>
                      <CustomImage
                        src='/new-images/sat-ets.svg'
                        alt='SATETS.svg'
                        width={157}
                        height={75}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Partner with us*/}
      <div id='kcedge' className={styles.kcedge}>
        <Container>
          <Col xs={12} lg={12} className='text-center'>
            <h2 className='text-center mb-5'>The KC Edge</h2>
          </Col>

          <Row className='text-center'>
            <Col xs={12} md={4} lg={4} className={styles.partnerSection}>
              <div>
                <CustomImage
                  src='/new-images/tie-ups.svg'
                  width={105}
                  height={75}
                  alt='tieUps'
                />
                <h3>47 Countries & 1200+ University Tie-ups</h3>
                <p>
                  The choices are endless and we are there to suggest you what
                  suits you the most.
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} lg={4} className={styles.partnerSection}>
              <div>
                <CustomImage
                  src='/new-images/the-way.svg'
                  width={105}
                  height={75}
                  alt='theWay'
                />
                <h3>Supporting you all the way</h3>
                <p>
                  From the day you consult us till the day you land in your
                  dream university; we will support you all the way and by all
                  means!
                </p>
              </div>
            </Col>
            <Col xs={12} md={4} lg={4} className={styles.partnerSection}>
              <div>
                <CustomImage
                  src='/new-images/speak-vol.svg'
                  width={105}
                  height={75}
                  alt='speakVol'
                />
                <h3>Our numbers speak volumes</h3>
                <p>
                  5,30,000+ students have benefited from our counselling &
                  services, and we will be happy to help you reach your academic
                  & career goals.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className={styles.sevenSetpesBg}>
        <SeveneasySteps />
      </div>
      {/* Webinar */}
      <div>
        <WebinarEvents headingLevel={2} />
      </div>
      <Testimonial
        title='Our students love us'
        bgColor='#FFFFFF'
        slug={`student-testimonials?_limit=15&_sort=id:DESC`}
      />
      <div className={styles.homePageLatestKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>
      <div className={styles.homePageBlogs}>
        <FeaturedBlogs />
      </div>
      <div id='office-address' className={styles.officeAddress} ref={scrollRef}>
        <Container>
          <Row className={styles.row}>
            <Col lg={6} md={6} xs={12}>
              <div className={styles.offices}>
                <h3 className={styles.DesktopViewHeading} id="desktopBranch">KC Overseas Education: {branchDetails?.city}</h3>
                <div className={`${styles.contactDetail} ${styles.addDisplay}`}>
                  <div className={styles.addImg}>
                    <CustomImage
                      src='/images/contcatus/addressiconcontact.svg'
                      alt='contact-location'
                      width={40}
                      height={40}
                      className={styles.img}
                    />
                  </div>
                  <div className={styles.content}>
                    <p>{branchDetails?.address}</p>
                  </div>
                </div>
                <div className={`${styles.contactDetail} ${styles.addDisplay}`}>
                  <div className={styles.addImg}>
                    <CustomImage
                      src='/images/contcatus/mobileiconcontact.svg'
                      alt='contact-location'
                      width={40}
                      height={40}
                      className={styles.img}
                    />
                  </div>
                  <div className={styles.content}>
                    <p className={styles.para}>{branchDetails?.mobile}</p>
                  </div>
                </div>
                <div className={`${styles.contactDetail} ${styles.addDisplay}`}>
                  <div className={styles.addImg}>
                    <CustomImage
                      src='/images/contcatus/emailiconcontcat.svg'
                      alt='contact-email'
                      width={40}
                      height={40}
                      className={styles.img}
                    />
                  </div>
                  <div className={styles.content}>
                    <p className={styles.para}>{branchDetails?.email}</p>
                  </div>
                </div>
                <div className={`${styles.contactDetail} ${styles.addDisplay}`}>
                  <div className={styles.addImg}>
                    <CustomImage
                      src='/images/contcatus/timingiconcontact.svg'
                      alt='contcat-clock'
                      width={40}
                      height={40}
                    />
                  </div>

                  <div className={styles.content}>
                    <p className={styles.para}>{branchDetails?.timings}</p>
                  </div>
                </div>
              </div>
            </Col>
            {branchDetails?.embedLocationUrl && (
              <Col lg={6} md={6} xs={12} className='mb-5'>
                 <h3 className={styles.mobileHeading} id="mobileBranch">KC Overseas Education: {branchDetails?.city}</h3>
                <div className={styles.map}>
                  <LazyMedia 
                    width='100%'
                    height='480px'
                    src={branchDetails?.embedLocationUrl}
                    tag='iframe'
                  />
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </div>

      
      {branchDetails?.socialMediaLinks && branchDetails.socialMediaLinks.length > 0 ? (
          <div className={styles.BranchSocialMedia}>
              <div className={styles.socialMedia}>
                  <Container>
                    <div className={styles.socialMediaDiv}>
                      <div className={styles.socialMediaLinks}>
                        <h3>{branchDetails.socialMediaTitle}</h3>
                        <Row className={styles.row}>
                          {branchDetails.socialMediaLinks.map((link:any) => (
                            <Col className={styles.col} key={link.id}>
                              <CustomLink data={link} alt={link.image?.alternativeText || link.image?.name}>
                                <CustomImage
                                  src={link.image?.url || '/'}
                                  alt={link.image?.alternativeText || link.image?.name}
                                  width={40}
                                  height={40}
                                />
                              </CustomLink>
                            </Col>
                          ))}
                        </Row>
                      </div>
                    </div>
              </Container>
        </div>
      </div> ) : null}
    </>
  );
};

export default Branchpage;